import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'wouter';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Statistic from './Statistic';
import StatisticsFilter from './StatisticsFilter';
import { loadClients } from '../../clients/clientsReducer';
import { loadDocumentation } from '../../documentation/documentationReducer';
import clientSelector from '../../clients/clientSelector';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import type { AppDispatch } from '../../store';
import type { Statistic as StatisticType } from '../../common/types/statistics/fbStatistics';
import { getClientPayloadType, getDocumentationPayloadType } from '../../common/helpers/payloadType';
import { loadAdvisors, loadGroups } from '../../settings/settingsReducer';

function Statistics({ filterStartYear }: { filterStartYear: number }) {
  const dispatch: AppDispatch = useDispatch();
  const [location] = useLocation();
  const clientStatus = useSelector(clientSelector.getStatus);
  const [statistic, setStatistic] = React.useState<StatisticType | null>();

  React.useEffect(() => {
    const clientPayloadType = getClientPayloadType(location);
    const documentationPayloadType = getDocumentationPayloadType(location);
    dispatch(loadClients(clientPayloadType));
    dispatch(loadDocumentation(documentationPayloadType));
    dispatch(loadAdvisors());
    dispatch(loadGroups());
  }, []);

  return (
    <Stack px={3} py={4} height='100%' overflow='auto scroll'>
      <Typography fontSize='1.5rem'>Statistik</Typography>
      <StatisticsFilter setStatistic={setStatistic} filterStartYear={filterStartYear} />
      {clientStatus === 'loading' ? (
        <LoadingIndicator />
      ) : (
        <Stack spacing={6}>
          <Statistic statistic={statistic} />
        </Stack>
      )}
    </Stack>
  );
}

export default Statistics;
